import {COMMON_BUILDING_TOKENS, KEY_POINT_TOKENS} from "../../constants/tokens";

/**
 * Добавить hex ключи в соответствующий массив в зависимости от того, является ли игрок текущим
 * @param {string[]} hexArray - массив hex ключей для добавления
 * @param {string[]} playerArray - массив для hex ключей игрока
 * @param {string[]} enemyArray - массив для hex ключей соперников
 * @param {boolean} isCurrentPlayer - является ли игрок текущим
 */
const pushHexKeysToArray = (hexArray, playerArray, enemyArray, isCurrentPlayer) => {
  if (!hexArray || !Array.isArray(hexArray)) {
    return;
  }

  const targetArray = isCurrentPlayer ? playerArray : enemyArray;
  for (const hexKey of hexArray) {
    targetArray.push(hexKey);
  }
};

/**
 * Получить ключи всех ячеек городов игрока и соперников
 * @returns {{playerCityHexKeys: string[], enemyCityHexKeys: string[]}}
 * @param citiesCache
 * @param currentPlayer
 */
export const getCityHexKeysForPlayerAndEnemies = (citiesCache, currentPlayer) => {
  const playerCityHexKeys = [];
  const enemyCityHexKeys = [];

  // Обрабатываем города всех игроков
  for (const [playerColor, playerCities] of Object.entries(citiesCache)) {
    if (!playerCities || !Array.isArray(playerCities)) {
      continue;
    }

    const isCurrentPlayer = playerColor === currentPlayer.color;

    for (const city of playerCities) {
      // Добавляем центральный квартал
      if (city.centralQuarter) {
        if (isCurrentPlayer) {
          playerCityHexKeys.push(city.centralQuarter);
        } else {
          enemyCityHexKeys.push(city.centralQuarter);
        }
      }

      const cityHexTypes = {
        ...COMMON_BUILDING_TOKENS,
        ...KEY_POINT_TOKENS,
      }

      Object.keys(cityHexTypes).forEach(key => {
        pushHexKeysToArray(city[cityHexTypes[key]], playerCityHexKeys, enemyCityHexKeys, isCurrentPlayer);
      });
    }
  }

  return {
    playerCityHexKeys,
    enemyCityHexKeys
  };
};
